import React from 'react';

import { Button } from 'components/Button';
import { createCustomerPortal } from 'api/subscription';
import { useAuth } from 'contexts/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';

import AppStoreIcon from 'assets/app_store_icon.svg';

import './style.css';

export const AccountPage = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const subSignupMethod = location.state.signupMethod;

  if (!auth.firebaseUser) {
    // We should never be able to get here!
    return (
      <>
        <p>You are not logged in.</p>;
        <button id='nav-to-login' onClick={() => navigate('/login')}>Login</button>
      </>
    );
  }

  const openCustomerPortal = async () => {
    try {
      const portalUrl = await createCustomerPortal(auth.user?.userId || '', window.location.href);
      // '_blank' if we want to open in a new tab
      window.open(portalUrl, '_self', 'noreferrer');
    } catch (error) {
      return;
    }
  };

  return (
    <div className='account-page-container'>
      <div className='account-container'>
        <h2 className='account-header'>Manage Your Subscription</h2>
        <div className='text-container'>
          <p className='management-text'>
        Looks like you have a subscription through {subSignupMethod == 'web' ? 'Stripe' : 'Apple'}.
        Go to the button below to manage your subscription.
        If you believe this is not the case, please email us at <a href="mailto:support@vlted.com">support@vlted.com</a>
          </p>
        </div>
        <div className='buttons-container'>
          {(subSignupMethod == 'web') ? (
            <Button
              accessibilityLabel='go-to-stripe-button'
              type='primary'
              text='Go to Stripe'
              handleOnClick={() => openCustomerPortal()}
            />
          ) : (
            <Button
              accessibilityLabel='go-to-apple-button'
              type='primary'
              text='Go to Apple'
              handleOnClick={() => window.open('https://apps.apple.com/account/subscriptions', '_blank')}
            />
          )}
          <Button
            accessibilityLabel='sign-out-button'
            type='secondary'
            text='Sign Out'
            handleOnClick={() => auth.logout(() => {
              navigate('/login');
            })}
          />
        </div>
      </div>
      <div className='download-message-container'>
        <p className='management-text'>
          Download the Vlted app on the App Store to get started!
        </p>
        <div className='download-button'>
          <img 
            // Might need to localize this in the future, or it might do it automatically
            className='download-image'
            onClick={()=> window.open('https://apps.apple.com/us/app/vlted/id6443393493', '_blank')}
            src={AppStoreIcon}/> 
        </div>
      </div>
      <div>
      </div>
    </div>
  );
};
